import type { DriveStep } from 'driver.js';

export const messagingTourSteps: DriveStep[] = [
  {
    element: '[data-tour="msg-toggle"]',
    popover: {
      title: 'Verfügbar / Im Coaching',
      description: 'Schalte hier um: "Im Coaching" aktiviert die Auto-Antwort — Klienten bekommen automatisch eine Abwesenheitsnotiz.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="msg-new-btn"]',
    popover: {
      title: 'Neue Konversation',
      description: 'Starte eine neue Konversation mit einem Klienten.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="msg-inbox"]',
    popover: {
      title: 'Konversationen',
      description: 'Alle Chats mit deinen Klienten. Ungelesene Nachrichten werden mit einem Badge markiert.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="msg-tabs"]',
    popover: {
      title: 'Aktiv & Archiv',
      description: 'Wechsle zwischen aktiven Konversationen und dem Archiv. Alte Chats werden automatisch archiviert.',
      side: 'bottom',
      align: 'start',
    },
  },
];
